import $ from "jquery";

export default function accordion() {
    $(".pxa-accordion").each(function () {
        const $accordion = $(this);
        
        $accordion.find("> .accordion-item > .accordion-toggle").on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            
            $(this).parent().siblings(".active").removeClass("active");
            $(this).parent().toggleClass("active");
        });
    });
}
